module.exports = __webpack_public_path__ + "static/assets/3209b00568ada095577332decaee31dc.png";